import { MouseEvent } from 'react';
import { useDomainModal } from '../DomainModalContext';

interface DomainNameProps {
  name?: string | null;
  /** Optional href to wrap with a link. When set, takes precedence over the modal click handler. */
  href?: string;
  /** Set to false to render plain text without click-to-open-modal behavior. */
  clickable?: boolean;
}

/** Renders a domain with the TLD muted (e.g. "crypto.io" → "crypto" + ".io").
 *  By default clicking the domain opens the global Domain Info modal. */
export function DomainName({ name, href, clickable = true }: DomainNameProps) {
  const { open } = useDomainModal();

  if (!name) return <span className="text-text-3">—</span>;
  const dot = name.indexOf('.');
  const sld = dot === -1 ? name : name.slice(0, dot);
  const tld = dot === -1 ? '' : name.slice(dot);

  const content = (
    <span className="text-text font-semibold">
      {sld}
      {tld && <span className="opacity-40">{tld}</span>}
    </span>
  );

  if (href) {
    return (
      <a href={href} className="no-underline hover:text-accent [&:hover_span]:text-accent [&:hover_span]:opacity-100">
        {content}
      </a>
    );
  }

  if (clickable) {
    const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
      open(name as string);
    };
    return (
      <button
        type="button"
        onClick={handleClick}
        className="text-left bg-transparent border-0 p-0 cursor-pointer hover:text-accent [&:hover_span]:text-accent [&:hover_span]:opacity-100"
      >
        {content}
      </button>
    );
  }

  return content;
}
